import { useState } from 'react';
import './ThemeMapsCreateForm.css';
import { useLocation } from 'react-router-dom';
import Modal from 'react-modal';
import { STYLE_MODAL } from '../../constants/components/exportImage';
import { BsXLg } from "react-icons/bs";

const ThemeMapsCreatePopup = () => {
  const location = useLocation();
  const isDev = location.pathname === '/dev';
  const [isThemeMapCreateOpen, setIsThemeMapCreateOpen] = useState(isDev);  

  /* *************
   * モーダルを閉じる
   * *************/
  const handleCloseModal = () => {
    setIsThemeMapCreateOpen(false);
  }

  return (
    <>
      <Modal
        isOpen={isThemeMapCreateOpen}
        onRequestClose={handleCloseModal}
        style={STYLE_MODAL}
        contentLabel="Example Modal"
        appElement={document.getElementById('root')!}
      >
        <div className='modal-inner'>
          <div className='modal-header'>
            <h2 className='modal-title'>テーマ図の書き出し</h2>
            <button className='theme-close-button' onClick={handleCloseModal}>
              <BsXLg />
            </button>
          </div>
          <div className='modal-body'>
            <div>サイドバーの「テーマ図作成」ボタンをクリックして設定ファイルをダウンロードし、手順に沿ってテーマ図を作成して下さい。</div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default ThemeMapsCreatePopup;
